import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=1e83ae5e&scoped=true&"
import script from "./TableBox.vue?vue&type=script&lang=js&"
export * from "./TableBox.vue?vue&type=script&lang=js&"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=1e83ae5e&lang=scss&scoped=true&"
import style1 from "./TableBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83ae5e",
  null
  
)

export default component.exports